import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { Grid, TextField } from '@mui/material';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function WhatsModal({ modal }) {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({
    message: '',
    order_id: '',
    whatsapp: '',
    error: false
  });
  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
      error: false
    });
  };

  useEffect(() => {
    setOpen(modal.open);
    setValues({
      ...values,
      order_id: modal.order_id
    });

    if (modal.phones.length > 0) {
      setValues({
        ...values,
        whatsapp: modal.phones[0].contact,
        order_id: modal.order_id
      });
    }
  }, [modal]);

  const handleConfirm = () => {
    if (values.reason_canceled === '') {
      setValues({
        ...values,
        error: true
      });
    } else {
      modal.confirm(values);
    }
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  return (
    <>
      <BootstrapDialog
        fullWidth
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Enviar Menssagem para Cliente Pelo WhatsApp
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            <Grid
              spacing={3}
              container
            >
              <Grid
                item
                xs={12}
              >
                <TextField
                  fullWidth
                  label="WhatsApp Cadastrado"
                  name="whatsapp"
                  onChange={handleChange}
                  required
                  select
                  SelectProps={{ native: true }}
                  value={values.client_status}
                  variant="outlined"
                >
                  {modal.phones.map((phone) => (
                    <option
                      key={phone.id}
                      value={phone.contact}
                    >
                      {`${phone.name} - ${phone.contact}`}
                    </option>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={12}
              >
                <TextField
                  error={values.error}
                  fullWidth
                  multiline
                  required
                  rows={4}
                  label="Descreva a menssagem"
                  name="message"
                  onChange={handleChange}
                  value={values.observation}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" autoFocus onClick={handleClose} color="default">
            Cancelar
          </Button>
          <Button variant="contained" onClick={handleConfirm} color="primary">
            Enviar
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}

WhatsModal.propTypes = {
  modal: PropTypes.object.isRequired
};
